import { useState } from 'react';
import { hotCategories, hotRankByCategory } from '@/mocks/wuyi';
import SectionHeading from './SectionHeading';

const trendIcon = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-600' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-accent-600' },
  same: { icon: 'ri-more-line', cls: 'text-foreground-400' },
} as const;

function rankStyle(r: number) {
  if (r <= 3) return 'bg-accent-500 text-background-50';
  if (r <= 6) return 'bg-secondary-500 text-background-50';
  return 'bg-background-200 text-foreground-700';
}

export default function HotList() {
  const [active, setActive] = useState('全部');
  const data = hotRankByCategory.find((d) => d.category === active)?.items ?? [];

  return (
    <section id="hotlist" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="全网话题 · TRENDING"
          title="五一话题"
          accent="热榜"
          desc="综合讨论量、阅读量与互动热度加权排序，看看这个假期大家在冲哪些话题。"
        />

        <div className="mx-auto mt-10 grid max-w-5xl gap-6 lg:grid-cols-[200px_1fr]">
          {/* 分类筛选 */}
          <div className="flex flex-row gap-2 overflow-x-auto lg:flex-col lg:gap-2 lg:overflow-visible">
            {hotCategories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActive(cat)}
                className={`whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors lg:justify-start ${
                  active === cat
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 hover:bg-background-200'
                }`}
              >
                <i
                  className={`${active === cat ? 'ri-disc-fill' : 'ri-disc-line'} text-base`}
                ></i>
                {cat}
              </button>
            ))}
          </div>

          {/* 榜单列表 */}
          <div className="flex flex-col gap-3">
            {data.map((item) => {
              const tr = trendIcon[item.trend];
              return (
                <button
                  key={`${active}-${item.rank}`}
                  type="button"
                  onClick={() => document.querySelector('#headlines')?.scrollIntoView({ behavior: 'smooth' })}
                  className="group flex w-full cursor-pointer items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 text-left transition-all hover:-translate-y-0.5 hover:border-primary-300"
                >
                  <span
                    className={`flex h-8 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg ${
                      item.rank <= 3 ? '' : ''
                    } ${rankStyle(item.rank)}`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-[15px] font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </p>
                    <span className="mt-1 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-price-tag-3-line text-accent-500"></i>
                      {item.tag}
                      <span className="mx-1 text-foreground-300">·</span>
                      <i className="ri-fire-line text-primary-500"></i>
                      热度 {item.hot} 万
                    </span>
                  </div>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-sm ${tr.cls}`}
                    aria-label={item.trend === 'up' ? '上升' : item.trend === 'down' ? '下降' : '持平'}
                  >
                    <i className={tr.icon}></i>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}